
const discover_bucket_labels = {
  kalshi_markets: "Kalshi markets",
  kalshi_events: "Kalshi events",
  polymarket_markets: "Polymarket markets",
  polymarket_events: "Polymarket events",
}

const DiscoverBulkStatusPanel = ({
  bulk_buckets,
  is_bulk_running,
  bulk_run_bucket,
  on_fetch_bucket,
  on_refresh_all,
  hide_inner_title,
}) => {
  const bucket_order = [
    "kalshi_markets",
    "kalshi_events",
    "polymarket_markets",
    "polymarket_events",
  ]

  return (
    <div className="space-y-4">
      <div
        className={
          hide_inner_title
            ? "flex flex-wrap items-center justify-end gap-3"
            : "flex flex-wrap items-center justify-between gap-3"
        }
      >
        {!hide_inner_title && (
          <div className="text-sm font-semibold text-gray-900">Bulk cache (Redis)</div>
        )}
        <button
          type="button"
          className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-semibold text-gray-700 hover:border-blue-300 hover:text-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
          onClick={() => on_refresh_all()}
          disabled={is_bulk_running}
        >
          {is_bulk_running ? "Refreshing all..." : "Refresh all four"}
        </button>
      </div>

      <p className="text-xs text-gray-500">
        Fetches full lists from the exchanges and stores them in Redis. Buttons stay disabled while a fetch is in progress.
      </p>

      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-xs font-semibold uppercase text-gray-500">
              <th className="py-2 pr-4">Dataset</th>
              <th className="py-2 pr-4">Last updated</th>
              <th className="py-2 pr-4">Count</th>
              <th className="py-2 pr-4">State</th>
              <th className="py-2">Fetch</th>
            </tr>
          </thead>
          <tbody>
            {bucket_order.map((bucket_id) => {
              const row = bulk_buckets[bucket_id] || {
                updated_at: null,
                count: 0,
                fetching: false,
                fetch_started_at: null,
                owner_id: null,
                last_fetch_started_at: null,
                last_fetch_owner_id: null,
              }
              const row_fetching = row.fetching === true
              const client_fetching_this_row =
                is_bulk_running
                && (bulk_run_bucket === "all" || bulk_run_bucket === bucket_id)
              const row_or_client_fetching = row_fetching || client_fetching_this_row
              const state_label =
                row_or_client_fetching
                  ? "fetching"
                  : "idle"
              const label = discover_bucket_labels[bucket_id] || bucket_id

              return (
                <tr key={bucket_id} className="border-b border-gray-100">
                  <td className="py-2 pr-4 font-medium text-gray-900">{label}</td>
                  <td className="py-2 pr-4 text-gray-600">
                    {row.updated_at ? new Date(row.updated_at).toLocaleString() : "—"}
                  </td>
                  <td className="py-2 pr-4 text-gray-600">{row.count ?? 0}</td>
                  <td className="py-2 pr-4 text-gray-600">
                    <div>{state_label}</div>
                    {row_or_client_fetching && (
                      <div className="mt-1 text-xs font-normal normal-case text-gray-500">
                        {row.owner_id ? <div>{row.owner_id}</div> : null}
                        {row.fetch_started_at ? (
                          <div>{new Date(row.fetch_started_at).toLocaleString()}</div>
                        ) : null}
                        {!row.owner_id && !row.fetch_started_at ? (
                          <div className="text-gray-400">Syncing status from server…</div>
                        ) : null}
                      </div>
                    )}
                  </td>
                  <td className="py-2">
                    <button
                      type="button"
                      className="rounded-md bg-blue-600 px-2 py-1 text-xs font-semibold text-white hover:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-60"
                      onClick={() => on_fetch_bucket(bucket_id)}
                      disabled={is_bulk_running || row_fetching}
                    >
                      Fetch
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default DiscoverBulkStatusPanel
